import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo, franchises } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main footer content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company info */}
          <div className="space-y-6">
            <img 
              src={companyInfo.logo} 
              alt="Logo SESAM" 
              className="h-12 w-auto brightness-0 invert"
            />
            <p className="text-gray-400 leading-relaxed">
              Leader de l'installation et de la gestion d'espaces publicitaires en Afrique centrale et de l'ouest.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="bg-gray-800 hover:bg-primary p-2 rounded-lg transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} aria-hidden="true" />
              </a>
              <a
                href="#"
                className="bg-gray-800 hover:bg-primary p-2 rounded-lg transition-colors"
                aria-label="Twitter"
              >
                <Twitter size={20} aria-hidden="true" />
              </a>
              <a
                href="#"
                className="bg-gray-800 hover:bg-primary p-2 rounded-lg transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} aria-hidden="true" />
              </a>
              <a
                href="#"
                className="bg-gray-800 hover:bg-primary p-2 rounded-lg transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Navigation</h3>
            <ul className="space-y-3" role="list">
              {[
                { label: 'Accueil', id: 'hero' },
                { label: 'Services', id: 'services' },
                { label: 'À propos', id: 'about' },
                { label: 'Présence', id: 'franchises' },
                { label: 'Contact', id: 'contact' }
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="hover:text-primary transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Nos Services</h3>
            <ul className="space-y-3" role="list">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-primary transition-colors"
                >
                  Panneaux Déroulants
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-primary transition-colors"
                >
                  Panneaux LED
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-primary transition-colors"
                >
                  Panneaux Grand Format
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-primary transition-colors"
                >
                  Solutions Personnalisées
                </button>
              </li>
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Contact</h3>
            <ul className="space-y-4" role="list">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="flex-shrink-0 mt-1 text-primary" aria-hidden="true" />
                <span className="text-gray-400">{companyInfo.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={20} className="flex-shrink-0 mt-1 text-primary" aria-hidden="true" />
                <div className="space-y-1">
                  {companyInfo.phone.map((phone, index) => (
                    <a
                      key={index}
                      href={`tel:${phone}`}
                      className="block text-gray-400 hover:text-primary transition-colors"
                    >
                      {phone}
                    </a>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={20} className="flex-shrink-0 mt-1 text-primary" aria-hidden="true" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-400 hover:text-primary transition-colors break-all"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Countries */}
        <div className="mt-12 pt-12 border-t border-gray-800">
          <h4 className="text-white font-bold text-center mb-6">Notre Présence</h4>
          <div className="flex flex-wrap justify-center gap-4">
            {franchises.map((franchise) => (
              <div
                key={franchise.id}
                className="bg-gray-800 px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors"
              >
                <span className="mr-2">{franchise.flag}</span>
                <span className="text-sm">{franchise.country}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© {currentYear} SESAM. Tous droits réservés.</p>
            <div className="flex gap-6">
              <button className="hover:text-primary transition-colors">
                Mentions légales
              </button>
              <button className="hover:text-primary transition-colors">
                Politique de confidentialité
              </button>
              <button className="hover:text-primary transition-colors">
                Conditions d'utilisation
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
